export default __webpack_public_path__ + "static/media/submitted_regular.815d854d.gif";